import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link, useNavigate } from "react-router-dom";
import { Register } from "../functions/authenticate";
import SpinnerLoader from "../components/spinnerLoader";
import bannerBgSVG from "../assets/media/banner_bg.svg";

export default function SignUp(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState(null);
  const [nameError, setNameError] = useState({ bool: false, value: "" });
  const [userid, setUserId] = useState(null);
  const [password, setPassword] = useState(null);
  const [useridError, setUserIdError] = useState({ bool: false, value: "" });
  const [passwordErr, setPasswordError] = useState({ bool: false, value: "" });
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const validateFields = async () => {
    const re = new RegExp(
      "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
    );
    if (!userid) {
      setUserIdError({ bool: true, value: "Invalid UserId" });
      return false;
    } else {
      setUserIdError({ bool: false, value: "" });
    }
    if (!name) {
      setNameError({ bool: true, value: "Invalid Name" });
      return false;
    } else {
      setNameError({ bool: false, value: "" });
    }
    let test = await re.test(password);
    if (test) {
      setPasswordError({ bool: false, value: "" });
    } else {
      setPasswordError({ bool: true, value: "Weak Password" });
      return false;
    }
    return true;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let validate = await validateFields();
    if (validate) {
      setLoad(true);
      const signObj = await Register(password, userid, name, navigate);
      if (signObj) {
        setUserId(null);
        setPassword(null);
        setName(null);
      }
    }
    setLoad(false);
  };

  const onChangeTxt = async (event, func) => {
    let value = event.target.value;
    func(value);
  };

  return (
    <Grid container>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgLeftBg" sx={{backgroundImage: `url(${bannerBgSVG})`}}>
        <Grid className="logoDiv">
          <img src="media/logo.svg" className="logoImg" />
        </Grid>
        <Grid className="roboDiv">
          <img src="media/robot.svg" className="roboImg" />
        </Grid>
      </Grid>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgRightBg">
        <div className="insideCont">
          <h1 className="lgTitle">Create an account</h1>
          {load ? (
            <SpinnerLoader visible={load} />
          ) : (
            <form onSubmit={onSubmit} onDragEnter={onSubmit}>
              <TextField
                fullWidth
                error={nameError.bool}
                id="outlined-error-helper-text"
                label="Full Name"
                className="formtext"
                value={name}
                onChange={(e) => {
                  onChangeTxt(e, setName);
                }}
                placeholder="kevin"
                autoComplete={false}
                helperText={nameError.value}
              />
              <TextField
                fullWidth
                error={useridError.bool}
                id="outlined-error-helper-text"
                label="User ID / Email"
                className="formtext"
                value={userid}
                onChange={(e) => {
                  onChangeTxt(e, setUserId);
                }}
                placeholder="kevin.hector@email.com"
                helperText={useridError.value}
                autoComplete={false}
              />
              <FormControl className="formtext" fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  fullWidth
                  error={passwordErr.bool}
                  value={password}
                  autoComplete={false}
                  onChange={(e) => {
                    onChangeTxt(e, setPassword);
                  }}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                {passwordErr.bool && (
                  <FormHelperText error id="outlined-adornment-error">
                    {passwordErr.value}
                  </FormHelperText>
                )}
              </FormControl>
              <Button type="submit" className="frmbtn" disabled={load}>
                CREATE ACCOUNT
              </Button>
            </form>
          )}
          <div className="subtxt">
            <span className="subtxt">
              Already have an account? <Link to="/login">Login here</Link>
            </span>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
